import type { LayoutLoad } from "./$types";

export const load = (async ({ data, params }) => {
  return {
    fixedHeader: true,
    query: data.query,
    categories: data.categories,
    template_counts: data.template_counts,
    nav_items: data.nav_items,
    seamlessMobile: true,
  };
}) satisfies LayoutLoad;
